import { graphql } from 'src/graphql';

export const RequestBookingTaskFileUploadDownload = graphql(`
  mutation RequestBookingTaskFileUploadDownload($input: BookingTaskFileUploadDownloadInput!) {
    requestBookingTaskFileUploadDownload(input: $input) {
      download_url
    }
  }
`);
